import { mapActions, mapMutations } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import FiltersSelect from '@/components/filters-select/filters-select.vue'

export default {
  name: 'Auth',
  components: {
    ValidationObserver,
    ValidationProvider,
    FiltersSelect
  },
  data() {
    return {
      login: '',
      password: '',
      serverError: ''
    }
  },
  created() {
    this.clearRouteTasks()
  },
  methods: {
    ...mapActions({
      loginUser: 'users/login',
      clearRouteTasks: 'collectOrders/clearRouteTasks'
    }),
    ...mapMutations({
      setLoading: 'pageLoader/SET_LOADING',
    }),
    onSubmit() {
      this.serverError = ''
      this.$refs.observer.validate().then(async success => {
        if (!success) {
          return
        }
        this.setLoading(true)
        try {
          await this.loginUser({
            login: this.login,
            password: this.password
          })
          /**
           * this.$router.replace({ name: 'main' }) - эта логика в app в watch
           * на user
           */
        } catch(e) {
          if (e.status === 401) {
            this.serverError = e.data.message
          } else {
            throw e
          }
        } finally {
          this.setLoading(false)
        }
      })
    }
  }
}